import rawData from '../data/DecorationItems.json';
import rawTierData from '../data/DecorationTiers.json';
import {
  DecorationItem,
  DecorationItemID,
  DecorationRoomID,
  DecorationSlot,
  DecorationThemeID,
  DecorationThemeVariant,
} from '../data/DecorationItems.schema';
import {
  DecorationTier,
  DecorationTierID,
} from '../data/DecorationTiers.schema';
import { exhaustiveTuple } from '../utils/types';

export type {
  DecorationItem,
  DecorationItemID,
  DecorationRoomID,
  DecorationThemeID,
  DecorationSlot,
};
export type { DecorationTier, DecorationTierID };

const data = rawData as DecorationItem[];
const tierData = rawTierData as DecorationTier[];

// Return typed data array
export const decorationItems: readonly DecorationItem[] = data;

// Return typed data map for optimized access by id
export const decorationItemsMap: Map<DecorationItemID, DecorationItem> =
  data.reduce((acc, item) => acc.set(item.id, item), new Map());

// Maps items to tiers using item id and tier id.
export const tiers = {} as Record<DecorationTierID, DecorationTier>;
export const tiersItemsMap = {} as Record<DecorationItemID, typeof tiers>;
tierData.forEach((tier) => {
  tiers[tier.id] = tier;

  if (!tiersItemsMap[tier.item_id]) {
    tiersItemsMap[tier.item_id] = {} as any;
  }
  tiersItemsMap[tier.item_id][tier.id] = tier;
});
// Map tiers by themes.
export const tiersByTheme = decorationItems.reduce(
  (acc, { id, room, theme, color, slot }) => {
    // Only living room for now.
    if (room !== 'living') return acc;

    if (!acc[theme]) acc[theme] = {} as any;
    if (!acc[theme][color]) acc[theme][color] = {} as any;
    if (!acc[theme][color][slot]) acc[theme][color][slot] = {} as any;
    if (!tiersItemsMap[id]) return acc;

    Object.values(tiersItemsMap[id]).forEach((tier) => {
      acc[theme][color][slot][tier.tier] = tier;
    });

    return acc;
  },
  {} as Record<
    DecorationThemeID,
    Record<
      DecorationThemeVariant,
      Record<DecorationSlot, Record<number, DecorationTier>>
    >
  >,
);

// Unlocked on player level
export const decorationUnlockLevel = 4;

// Create a tuple of all decoration slots.
export const decorationSlots = exhaustiveTuple<DecorationSlot>()(
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
);
